import React from 'react';
import { AuthContext } from 'buzz_lib_auth';
import { Header, Text, SystemPanel, getTheme } from 'buzz_lib_ui';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Holding = _ref => {
  let {
    message
  } = _ref;
  const authContext = React.useContext(AuthContext);
  const theme = getTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      onLogout: authContext === null || authContext === void 0 ? void 0 : authContext.logout,
      children: "Buzz "
    }), /*#__PURE__*/_jsx(SystemPanel, {
      iconName: "Airplane",
      iconColour: theme.palette.blue,
      title: "Welcome to Buzz",
      content: /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx("strong", {
          children: message
        })
      })
    })]
  });
};
export default Holding;